import CategoryPageSection from 'components/CategoryPage/CategoryPageSection/CategoryPageSection';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getPersonalisedProduct from 'store/product/selector/getPersonalisedProduct';
import { RecommendedProduct } from 'store/product/types';
import Carousel from '../Carousel/Carousel';
import YouWillAlsoLikeProduct from './YouWillAlsoLikeProduct/YouWillAlsoLikeProduct';
import styles from './YouWillAlsoLike.module.scss';

const YouWillAlsoLike = () => {
  const { t } = useTranslation();
  const personalisedProduct = useSelector(getPersonalisedProduct);
  const items = (personalisedProduct as any)?.recommendedProduct as RecommendedProduct[];

  if (!items || !items.length) return null;

  return (
    <section className={styles.youWillAlsoLike}>
      <CategoryPageSection>{t('txt_you_will_also_like')}</CategoryPageSection>
      <Carousel className={styles.carousel}>
        {items.map((product, index) => (
          <YouWillAlsoLikeProduct key={`item_${index}`} product={product} />
        ))}
      </Carousel>
    </section>
  );
};

export default YouWillAlsoLike;
